import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProfile,
  fetchCitys,
  fetchHotels,
  createTrip,
  getTrip,
  fetchHomePage,
  fetchProducts,
  fetchDesigners,
  fetchCategories,
  fetchSellerDetails,
  fetchProductDetails,
  updateTrip,
  updateProfile,
  fetchColours,
  fetchSizes
} from "./apiThunk";
import { ToastNotifyError } from "../../../components/CommonComponents/Toast/ToastNotify";
import { USER_ERROR_MESSAGE } from "../../../constants/errorMessages";

const initialData = {
  hotels: [],
  cityNames: [],
  isLoading: false,
  error: null,
  tripCreated: false,
  tripDetails: [],
  homePageContent: [],
  products: [],
  user: {},
  designers: [],
  categories: [],
  sellerDetails: [],
  productDetails : [],
  tripUpdated: false,
  colours: [],
  sizes: []
};

const homeSlice = createSlice({
  name: "home",
  initialState: { ...initialData },
  reducers: {
    resetHomeData: (state) => {
      state.hotels = [];
      state.cityNames = [];
      state.tripCreated = false;
      state.tripDetails = false;
      state.homePageContent = [];
      state.products = [];
      state.designers = []
      state.categories = []
      state.sellerDetails = []
      state.profile = [];
      state.productDetails = [];
      state.tripUpdated = false;
    },
    updateHotels: (state, action) => {
      state.hotels = action.payload;
    },
    updateCityNames: (state, action) => {
      state.cityNames = action.payload;
    },
    resetTripStatus: (state) => {
      state.tripCreated = false;
    },
    updateHomePage: (state, action) => {
      state.homePageContent = action.payload;
    },
    updateProducts: (state, action) => {
      state.products = action.payload;
    },
    updateDesigners: (state, action) => {
      state.products = action.payload;
    },
    updateCategories: (state, action) => {
      state.categories = action.payload;
    },
    updateSellerDetails: (state, action) => {
      state.sellerDetails = action.payload;
    },
    updateProfile: (state, action) => {
      state.profile = action.payload;
    },
    updateUpdateTrip: (state, action) => {
      state.tripUpdated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Hotels
      .addCase(fetchHotels.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchHotels.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hotels = action.payload.names || [];
      })
      .addCase(fetchHotels.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })

      // Fetch Products
      .addCase(fetchProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload.data || [];
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })

       // Fetch Product Details
       .addCase(fetchProductDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.productDetails = action.payload.data || [];
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })

      // Fetch Designers
      .addCase(fetchDesigners.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDesigners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.designers = action.payload.data || [];
      })
      .addCase(fetchDesigners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })


      // Fetch Seller Details
      .addCase(fetchSellerDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSellerDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.sellerDetails = action.payload.data || [];
      })
      .addCase(fetchSellerDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })


      // Fetch Categories
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categories = action.payload.data || [];
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })

      // Fetch Home Page
      .addCase(fetchHomePage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchHomePage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.homePageContent = action?.payload?.data || [];
      })
      .addCase(fetchHomePage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })

      // Fetch Cities
      .addCase(fetchCitys.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCitys.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cityNames = action.payload.names || [];
      })
      .addCase(fetchCitys.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })


      // Create Trip
      .addCase(createTrip.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.tripCreated = false; 
      })
      .addCase(createTrip.fulfilled, (state) => {
        state.isLoading = false;
        state.tripCreated = true; 
      })
      .addCase(createTrip.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.tripCreated = false;
        // ToastNotifyError("Failed to create trip.");
      })

      // Update Trip
      .addCase(updateTrip.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.tripUpdated = false; 
      })
      .addCase(updateTrip.fulfilled, (state) => {
        state.isLoading = false;
        state.tripUpdated = true; 
      })
      .addCase(updateTrip.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.tripUpdated = false;
        // ToastNotifyError("Failed to create trip.");
      })
       
      // get Trip details
      .addCase(getTrip.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.tripDetails = false; 
      })
      .addCase(getTrip.fulfilled, (state) => {
        state.isLoading = false;
        state.tripDetails = true; 
      })
      .addCase(getTrip.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.tripDetails = false;
        
      })

      //Fetch User Profile
      .addCase(fetchProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        ToastNotifyError(USER_ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      })
      .addCase(updateProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // Fetch Colours
      .addCase(fetchColours.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchColours.fulfilled, (state, action) => {
        state.isLoading = false;
        state.colours = action.payload.data || [];
      })
      .addCase(fetchColours.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message; 
      })

      // Fetch Sizes
      .addCase(fetchSizes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSizes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.sizes = action.payload.data || [];
      })  
      .addCase(fetchSizes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
  },
});

const {
  actions: {
    resetHomeData,
    updateHotels,
    updateCityNames,
    resetTripStatus,
    updateHomePage,
  },
  reducer,
} = homeSlice;

// Selector to access home slice data
const selectorHome = (state) => state.home;

export {
  resetHomeData,
  updateHotels,
  updateCityNames,
  resetTripStatus,
  selectorHome,
  updateHomePage,
};

export default reducer;
